import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useRole } from "components/Hooks/UserHooks";
import FeatherIcon from "feather-icons-react";
import { useTranslation } from "react-i18next";
import { ROUTES } from "routes/allRoutes";

const Navdata = () => {
  const history = useNavigate();
  const { userPermissions } = useRole();

  const [menuActive, setMenuActive] = useState<string>("DASHBOARD");
  const { t } = useTranslation();

  function updateIconSidebar(e: any) {
    if (e && e.target && e.target.getAttribute("sub-items")) {
      const ul: any = document.getElementById("two-column-menu");
      const iconItems = ul.querySelectorAll(".nav-icon.active");
      let activeIconItems = [...iconItems];
      activeIconItems.forEach((item) => {
        item.classList.remove("active");
        var id = item.getAttribute("sub-items");
        const getID = document.getElementById(id) as HTMLElement;
        if (getID) getID.classList.remove("show");
      });
    }
  }

  useEffect(() => {
    document.body.classList.remove("twocolumn-panel");
  }, [history]);

  const menuItems: any = [
    {
      id: "token",
      label: t("Token"),
      icon: <FeatherIcon icon="database" className="icon-dual" />,
      link: ROUTES.TOKEN,
      click: function (e: any) {
        setMenuActive((prev) => "TOKEN");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "TOKEN",
      isShow: true,
      // subItems: []
    },
    {
      id: "pool",
      label: t("Pool Management"),
      icon: <FeatherIcon icon="repeat" className="icon-dual" />,
      link: ROUTES.POOL,
      click: function (e: any) {
        setMenuActive((prev) => "POOL");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "POOL",
      isShow: true,
      // subItems: []
    },
    {
      id: "trade",
      label: t("Trade"),
      icon: <FeatherIcon icon="trending-up" className="icon-dual" />,
      link: ROUTES.TRADE,
      click: function (e: any) {
        setMenuActive((prev) => "TRADE");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "TRADE",
      isShow: true,
      // subItems: []
    },
    {
      id: "wallet",
      label: t("Wallet"),
      icon: <FeatherIcon icon="credit-card" className="icon-dual" />,
      link: ROUTES.WALLET,
      click: function (e: any) {
        setMenuActive((prev) => "WALLET");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "WALLET",
      isShow: true,
      // subItems: []
    },
    {
      id: "campaign",
      label: t("Campaign"),
      icon: <FeatherIcon icon="layers" className="icon-dual" />,
      link: ROUTES.CAMPAIGN,
      click: function (e: any) {
        setMenuActive((prev) => "CAMPAIGN");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "CAMPAIGN",
      isShow: true,
      // subItems: []
    },
    {
      id: "log",
      label: t("Event Log"),
      icon: <FeatherIcon icon="clock" className="icon-dual" />,
      link: ROUTES.EVENT_LOG,
      click: function (e: any) {
        setMenuActive((prev) => "EVENT_LOG");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "EVENT_LOG",
      isShow: true,
      // subItems: []
    },
    {
      id: "monitoring",
      label: t("Monitoring"),
      icon: <i className="ri-line-chart-fill" />,
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setMenuActive((prev) => "MONITORING");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "MONITORING",
      isShow: true,
      subItems: [
        {
          id: "liquidity-log",
          label: t("Liquidity Log"),
          link: ROUTES.LIQUIDITY_LOG,
          isShow: true,
        },
        {
          id: "transaction-log",
          label: t("Transaction Log"),
          link: ROUTES.TRANSACTION_LOG,
          isShow: true,
        },
      ],
    },
    {
      id: "settings",
      label: t("Settings"),
      icon: <FeatherIcon icon="settings" className="icon-dual" />,
      link: "/#",
      click: function (e: any) {
        e.preventDefault();
        setMenuActive((prev) => "SETTINGS");
        updateIconSidebar(e);
      },
      stateVariables: menuActive === "SETTINGS",
      isShow: true,
      subItems: [
        // {
        //   id: "trade-settings",
        //   label: t("Trade Settings"),
        //   link: ROUTES.TRADE_SETTINGS,
        //   isShow: true,
        // },
        // {
        //   id: "wallet-settings",
        //   label: t("Wallet Settings"),
        //   link: ROUTES.WALLET_SETTINGS,
        //   isShow: true,
        // },
        {
          id: "alert-settings",
          label: t("Alert Settings"),
          link: ROUTES.ALERT_SETTINGS,
          isShow: true,
        },
      ],
    },
  ];
  return <React.Fragment>{menuItems}</React.Fragment>;
};
export default Navdata;
